// extracted by mini-css-extract-plugin
module.exports = {"Security":"style_Security__2ObzP","Tittle":"style_Tittle__2lcAr","DisconectInfo":"style_DisconectInfo__2nRbK","DisconectBtn":"style_DisconectBtn__gstyG"};